import React from 'react';
import { useCases } from '../mock';
import { Check, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export default function UseCases() {
  return (
    <section className="relative py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="text-xs tracking-[0.3em] text-sky-600 font-semibold uppercase mb-3">Use Cases</div>
          <h2 className="font-display text-4xl md:text-5xl font-semibold text-slate-900 leading-tight">
            Built for the places <span className="water-text">luxury travels</span>
          </h2>
          <p className="mt-4 text-slate-600">Two flagship deployments. One promise: pure, endless, self-generated water.</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {useCases.map((u, idx) => (
            <div key={u.id} id={u.id} className="group relative rounded-[2.5rem] overflow-hidden bg-gradient-to-br from-slate-900 to-sky-900 min-h-[520px]">
              <img src={u.image} alt={u.title} className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-70 group-hover:scale-105 transition-all duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950/90 via-slate-900/40 to-transparent" />
              <div className="relative h-full p-8 lg:p-10 flex flex-col justify-end min-h-[520px]">
                <div className="inline-flex self-start items-center gap-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur border border-white/20 text-white text-xs mb-4">
                  <span className="w-1.5 h-1.5 rounded-full bg-cyan-300" /> {idx === 0 ? 'Hospitality' : 'Marine'}
                </div>
                <h3 className="font-display text-3xl md:text-4xl font-semibold text-white leading-tight">{u.title}</h3>
                <ul className="mt-6 space-y-3">
                  {u.points.map((pt) => (
                    <li key={pt} className="flex items-start gap-3 text-white/90 text-sm">
                      <span className="mt-0.5 w-5 h-5 rounded-full bg-cyan-400 flex items-center justify-center flex-shrink-0">
                        <Check className="w-3 h-3 text-slate-900" strokeWidth={3} />
                      </span>
                      {pt}
                    </li>
                  ))}
                </ul>
                <div className="mt-8">
                  <Button className="bg-white text-slate-900 hover:bg-sky-100 rounded-full px-6" onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}>
                    Design my system <ArrowRight className="ml-2 w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
